export const addBusinessIreland = {
  business_address: {
    postcode: {
      label: 'Eircode',
      required: 'Eircode is Required',
    },
  },
  owner_address: {
    postcode: {
      label: 'Eircode',
      required: 'Eircode is Required',
    },
  },
}
